module.exports = __webpack_public_path__ + "img/cg.01aaecd6.svg";